module.exports = __webpack_public_path__ + "img/人工智能.8fc20b11.jpg";